/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbButton } from "abreact/misc/AbButton";
import { AbDialog } from "abreact/popup/AbDialog";
import { AbDialogButtonBar } from "abreact/popup/AbDialogButtonBar";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import * as React from "react";
// The dialog shown from popup utils, separated out into its own component.
// This has been separated out to make webpack's react reload (aka hot module replacement)
// work better.  Without it, any component used here can not be hot reloaded,
// since they would be used by non-react code (by PopupUtils).
export function PopupUtilsModal(props) {
  return /*#__PURE__*/React.createElement(AbDialog, {
    dataTestId: props.dataTestId,
    title: props.dialogTitle,
    closeButton: props.closeButton,
    resizable: false,
    onClose: props.onClose,
    buttonBar: /*#__PURE__*/React.createElement(AbDialogButtonBar, null, /*#__PURE__*/React.createElement(AbButton, {
      dataTestId: "confirm-button",
      onClick: props.confirmOnClick,
      label: props.confirmButtonText
    }), props.rejectButtonText != null && /*#__PURE__*/React.createElement(AbButton, {
      dataTestId: "reject-button",
      onClick: props.rejectOnClick,
      label: props.rejectButtonText
    }), props.showCancelButton && /*#__PURE__*/React.createElement(AbButton, {
      dataTestId: "cancel-button",
      onClick: props.cancelOnClick,
      label: AbWebResources.cancel()
    }))
  }, props.message);
}
//# sourceMappingURL=PopupUtilsModal.js.map
